import { ContactViaEnum } from '../../enums/score-cards/contact-via.enum'
import { EvalutationEnum } from '../../enums/staff-application/evalutation.enum'
import { StatusOption } from '../../utils'
import { FileInput } from '../file/file-input'
import { Hobby } from '../hobby/hobby'
import { LanguageLevel } from '../languages/language-level'
import { PcrLight } from '../pcr/pcr'
import { StaffApplication } from '../staff-application/staff-application'

export interface ScoreCard {
  id: number

  current?: boolean

  contactedViaEmail?: boolean
  contactedViaPhone?: boolean

  // candidate details
  firstContactDate?: string
  firstContactVia?: ContactViaEnum
  secondContactDate?: string
  secondContactVia?: ContactViaEnum
  thirdContactDate?: string
  thirdContactVia?: ContactViaEnum
  classifiedDate?: string | null

  //  interview details
  interviewStartDate?: string
  interviewStartHour?: number
  interviewStartMinute?: number
  transcript?: FileInput
  transcriptId?: number
  video?: FileInput
  videoId?: number

  // evaluation
  levelOfLanguages: LanguageLevel[]

  presentation?: EvalutationEnum
  ponctuality?: EvalutationEnum
  motivation?: EvalutationEnum
  senseOfResponsability?: EvalutationEnum
  relevanceOfAnswer?: EvalutationEnum
  elocution?: EvalutationEnum
  reactivity?: EvalutationEnum
  globalAppreciation?: EvalutationEnum

  isApplicantRecommendedForHire?: boolean

  doesKnowLECPerson?: string
  comments?: string
  doesHaveAPeculiarTalent?: string

  applicationId: number
  application: StaffApplication

  hobbies: Hobby[]

  pcrId: number
  pcr: PcrLight

  paidToPCR?: boolean
  amountPaidToPCR?: number
  dateOfPayment?: Date
}

export type ScoreCardLight = Pick<
  ScoreCard,
  | 'id'
  | 'pcrId'
  | 'current'
  | 'paidToPCR'
  | 'applicationId'
  | 'amountPaidToPCR'
  | 'dateOfPayment'
  | 'isApplicantRecommendedForHire'
  | 'interviewStartDate'
>

export const pcrResult = (
  isApplicantRecommendedForHire?: boolean | null,
  pcrId?: number
): StatusOption => {
  return {
    variant:
      isApplicantRecommendedForHire == null || pcrId === null
        ? 'grey'
        : isApplicantRecommendedForHire
          ? 'success'
          : 'danger',
    label:
      isApplicantRecommendedForHire == null || pcrId === null
        ? 'Non évalué'
        : isApplicantRecommendedForHire
          ? 'A embaucher'
          : 'A refuser'
  }
}

export const paymentStatusMapping = (paidToPcr?: boolean | null): string => {
  return paidToPcr === null ? 'En attente' : paidToPcr ? 'Payé' : 'Non payé'
}
